"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentsDeletionDate = exports.DOCUMENT_DELETION_NOTICE_DAYS = exports.getDocumentsDeleteOn = exports.resolveAccountSettings = void 0;
const types_1 = require("@shared/types");
/** An account's effective settings: its stored values over the defaults. */
const resolveAccountSettings = (stored) => ({
    ...types_1.ACCOUNT_SETTING_DEFAULTS,
    ...stored,
});
exports.resolveAccountSettings = resolveAccountSettings;
const MS_PER_DAY = 24 * 60 * 60 * 1000;
/**
 * When an archived project's documents (those not marked keep) are due to be deleted: its archive
 * date plus the account's retention period. Null when it isn't archived or the account keeps
 * documents forever. Always derived from the current setting, so changing it moves every date.
 */
const getDocumentsDeleteOn = (archivedAt, settings) => {
    if (!archivedAt || settings.documentRetentionDays === null)
        return null;
    return new Date(new Date(archivedAt).getTime() +
        settings.documentRetentionDays * MS_PER_DAY);
};
exports.getDocumentsDeleteOn = getDocumentsDeleteOn;
/** Members get at least this much notice, from the first warning email, before documents are deleted */
exports.DOCUMENT_DELETION_NOTICE_DAYS = 14;
/**
 * When an archived project's documents will actually be deleted: their retention date, but never
 * less than DOCUMENT_DELETION_NOTICE_DAYS after the first warning (or from now, if it hasn't gone
 * out yet), so shortening the retention period can't cut the notice short. Null when the project
 * isn't archived or the account keeps documents forever.
 */
const getDocumentsDeletionDate = (project, settings, now = new Date()) => {
    const retentionDate = (0, exports.getDocumentsDeleteOn)(project.archived_at, settings);
    if (!retentionDate)
        return null;
    const noticeFrom = project.documents_warned_at
        ? new Date(project.documents_warned_at)
        : now;
    const noticeEnds = noticeFrom.getTime() + exports.DOCUMENT_DELETION_NOTICE_DAYS * MS_PER_DAY;
    return new Date(Math.max(retentionDate.getTime(), noticeEnds));
};
exports.getDocumentsDeletionDate = getDocumentsDeletionDate;
//# sourceMappingURL=account-settings.js.map